export default __webpack_public_path__ + "static/media/keto_digestion@3x.05bb6330.jpg";